const normalizeSelection = (selection) => {
  if (!selection) return null;
  if (typeof selection === "string") {
    return { name: selection };
  }
  return selection;
};

export const startCheckout = (selection) => {
  const scooter = normalizeSelection(selection);

  if (!scooter?.name) {
    alert("Please choose a scooter model first.");
    window.location.href = "/scooters";
    return;
  }

  const model = encodeURIComponent(scooter.name);
  window.location.href = `/api/shopify/create-checkout.php?model=${model}`;
};
